import { Dialog, DialogProps } from "../../core/components/dialog";
import { Config } from "../../core/config/config";
import { Helper } from "../../core/util/helper";
import { ResourcePlanningEntity } from "../resourcePlanning";
import React from "react";
import ReactDOM from "react-dom";

export const OpenResourcePlanningResetSendStateDialog = (entity: ResourcePlanningEntity, title: string) => {
    return new Promise<boolean>((resolve) => {
        const targetElement = $("<div>");
        const root = ReactDOM["createRoot"](targetElement[0]);
        const props: any = {
            onOk: () => {
                resolve(true)
            },
            onCancel: () => {
                resolve(false);
                root.unmount();
            },
            entity: entity,
            title: title
        }
        $("body").append(targetElement);
        root.render(<ResourcePlanningResetSendStateDialog {...props} />);
    })
}

class ResourcePlanningResetSendStateDialog extends React.Component<{
    entity: ResourcePlanningEntity;
    title: string;
    onOk: () => void;
    onCancel: () => void;
}, {
    }>{
    private _dialogProps: DialogProps = {
        title: this.props.title,
        actions: [
            {
                label: Config.translations.cancel,
                action: () => { }
            },
            {
                label: Config.translations.ok,
                action: () => {
                    this.props.onOk();
                },
                primary: true
            }
        ],
        afterClose: () => {
            this.props.onCancel();
        },
        width: 500
    };

    constructor(props) {
        super(props);
        this.state = {

        };
    }

    private getInMobileFieldServiceWarning = () => {
        if (Helper.hasValue(this.props.entity.Datenpaket))
            return <div>{Helper.getTranslation("Einsatz.AlreadySendMobFieldService")}</div>;
        else
            return null
    }

    private getInMobileAppWarning = () => {
        if (this.props.entity.IsSendToMobileApp)
            return <div>{Helper.getTranslation("Einsatz.AlreadySendMobApp")}</div>
        else
            return null
    }

    render() {
        let showDialog = Helper.hasValue(this.props.entity.Datenpaket) || this.props.entity.IsSendToMobileApp;

        if (!showDialog)
            this.props.onOk();

        return (<>
            <Dialog {...this._dialogProps} open={showDialog}>
                <div style={{ display: "flex", flexDirection: "column" }} >
                    {this.getInMobileFieldServiceWarning()}
                    {this.getInMobileAppWarning()}
                </div>
            </Dialog>
        </>)
    }
}